"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["OpenModal"] = "open_modal";
    ActionType["CloseModal"] = "close_modal";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
;
